<template>
  <a-modal
    title="Reply to Review"
    :visible="open"
    :confirm-loading="submitLoading"
    ok-text="Confirm Reply"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item label="Reply Content" prop="replyContent">
        <a-textarea
          v-model="form.replyContent"
          :max-length="1000"
          :auto-size="{ minRows: 5, maxRows: 10 }"
          placeholder="Please enter reply content"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { replyReview } from '@/api/order/review'

export default {
  name: 'ReplyForm',
  data () {
    return {
      open: false,
      submitLoading: false,
      form: {
        id: undefined,
        replyContent: ''
      },
      rules: {
        replyContent: [
          { required: true, message: 'Please enter reply content', trigger: 'blur' },
          { max: 1000, message: 'Reply content cannot exceed 1000 characters', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleReply (record) {
      this.form = {
        id: record.id,
        replyContent: record.replyContent || ''
      }
      this.open = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    cancel () {
      this.open = false
      this.form = { id: undefined, replyContent: '' }
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        replyReview(this.form).then(() => {
          this.$message.success('Reply successful')
          this.cancel()
          this.$emit('ok')
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
